module.exports = __webpack_public_path__ + "img/cutter.83898543.png";